<article class="rv" *ngIf="report">
  <header class="rv-head">
    <div class="rv-title">
      <span class="rv-type">{{ typeLabel }}</span>
      <h2>{{ report.title }}</h2>
      <div class="rv-meta">
        <span class="badge" [class.badge-ai]="report.ai_used" [class.badge-off]="!report.ai_used">
          {{ report.ai_used ? 'AI · ' + (report.model || 'LLM') : 'AI off · rule-based' }}
        </span>
        <span>Generated {{ report.created_at | date: 'medium' }}</span>
      </div>
    </div>
    <div class="rv-actions">
      <button type="button" class="btn ghost" (click)="exportPdf()" [disabled]="busy">PDF</button>
      <button type="button" class="btn ghost" (click)="exportExcel()" [disabled]="busy">Excel</button>
      <button type="button" class="btn primary" *ngIf="showRegenerate" (click)="regenerate.emit()" [disabled]="busy">
        {{ busy ? 'Generating…' : 'Regenerate' }}
      </button>
    </div>
  </header>

  <p class="rv-note" *ngIf="aiNote">{{ aiNote }} The narrative below was built from rules over the same figures.</p>

  <section class="rv-narrative">
    <h3>{{ report.narrative.headline }}</h3>
    <p>{{ report.narrative.summary }}</p>
  </section>

  <section class="rv-kpis">
    <div class="kpi" *ngFor="let k of report.facts.kpis">
      <span class="kpi-label">{{ k.label }}</span>
      <span class="kpi-value">{{ formatKpi(k) }}</span>
    </div>
  </section>

  <section class="rv-grid">
    <div class="rv-block" *ngIf="report.narrative.risks?.length">
      <h4>Risks and issues</h4>
      <ul class="risks">
        <li *ngFor="let r of report.narrative.risks" [attr.data-sev]="r.severity">
          <span class="sev">{{ r.severity }}</span>{{ r.text }}
        </li>
      </ul>
    </div>
    <div class="rv-block" *ngIf="report.narrative.highlights?.length">
      <h4>Highlights</h4>
      <ul><li *ngFor="let h of report.narrative.highlights">{{ h }}</li></ul>
    </div>
    <div class="rv-block" *ngIf="report.narrative.recommendations?.length">
      <h4>Recommendations</h4>
      <ul><li *ngFor="let h of report.narrative.recommendations">{{ h }}</li></ul>
    </div>
    <div class="rv-block muted" *ngIf="report.narrative.data_gaps?.length">
      <h4>Data gaps</h4>
      <ul><li *ngFor="let h of report.narrative.data_gaps">{{ h }}</li></ul>
    </div>
  </section>

  <section class="rv-table" *ngFor="let t of visibleTables">
    <h4>
      {{ t.title }}
      <small *ngIf="t.truncated">top {{ t.rows.length }} of {{ t.total_rows }}</small>
    </h4>
    <div class="table-wrap">
      <table>
        <thead>
          <tr><th *ngFor="let c of t.columns" [class.num]="c.numeric">{{ c.label }}</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of t.rows">
            <td *ngFor="let c of t.columns" [class.num]="c.numeric">{{ formatCell(row[c.key], c.numeric) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <p class="rv-empty" *ngIf="emptyTables.length">
    No records for: {{ emptyTableTitles }}.
  </p>

  <footer class="rv-foot">Figures come from project records. The narrative is AI-assisted and should be reviewed before sharing.</footer>
</article>
